/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Yummy_Opossum_HushInputs */

const fr_gray_yummy_opossum_hush = /** @type {(inputs: Gray_Yummy_Opossum_HushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus`)
};

/**

* @param {Gray_Yummy_Opossum_HushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const gray_yummy_opossum_hush = /** @type {((inputs?: Gray_Yummy_Opossum_HushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Yummy_Opossum_HushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_gray_yummy_opossum_hush(inputs)
});